import { render, staticRenderFns } from "./nutritionalPlan.vue?vue&type=template&id=00b88fe8&scoped=true&"
import script from "./nutritionalPlan.vue?vue&type=script&lang=js&"
export * from "./nutritionalPlan.vue?vue&type=script&lang=js&"
import style0 from "./nutritionalPlan.vue?vue&type=style&index=0&id=00b88fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b88fe8",
  null
  
)

export default component.exports